import { Strategy as StrategyType, VIDEO_TACTICS } from './utils'
import Styles from './StrategiesSelection.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { pluralize } from 'utils'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ProviderIcon } from 'screens/Calendar/WeekViewV2/CalendarEventCard/Icon'
import { SOCIAL_TACTICS } from './utils'
import { TACTIC_TO_PROVIDER } from 'screens/blaze/Home/VirtualMarketerHome/Brain/PlatformSection/Types'

export interface StrategyValuesProps {
  strategy: StrategyType
}

export const StrategyValues = ({ strategy }: StrategyValuesProps) => {
  const seoContentsCount = strategy.seo_contents.find((content) => content.type === 'blog_post')?.count || 0
  const newsletterContentsCount = strategy.email_contents.find((content) => content.type === 'newsletter')?.count || 0
  const crosspostContentsCount = strategy.crosspost_contents.find((content) => content.type === 'post')?.count || 0
  const videoCrosspostContentsCount =
    strategy.video_crosspost_contents.find((content) => content.type === 'post')?.count || 0

  const socialTactics = strategy.tactics.filter((tactic) => SOCIAL_TACTICS.includes(tactic))
  const videoTactics = strategy.tactics.filter((tactic) => VIDEO_TACTICS.includes(tactic))

  return (
    <div className={Styles.strategyValues}>
      {crosspostContentsCount > 0 && (
        <>
          <div className={Styles.strategyValue}>
            <div className={Styles.providerIcons}>
              {socialTactics.map((provider) => (
                <ProviderIcon
                  key={provider}
                  provider={TACTIC_TO_PROVIDER.find((t) => t.tactic === provider)?.provider as ExternalIntegrationEnum}
                  size={16}
                  isHovered={false}
                  zIndex={0}
                  borderColor="rgba(247, 247, 247, 1)"
                  marginLeft={-5}
                />
              ))}
            </div>
            <Text variant="secondary">
              {crosspostContentsCount} {pluralize('post', crosspostContentsCount)}
            </Text>
            <Text variant="secondary" color="var(--dark-40)">
              /week
            </Text>
          </div>
          <div className={Styles.separator} />
        </>
      )}
      {videoCrosspostContentsCount > 0 && (
        <>
          <div className={Styles.strategyValue}>
            <div className={Styles.providerIcons}>
              {videoTactics.map((provider) => (
                <ProviderIcon
                  key={provider}
                  provider={TACTIC_TO_PROVIDER.find((t) => t.tactic === provider)?.provider as ExternalIntegrationEnum}
                  size={16}
                  isHovered={false}
                  zIndex={0}
                  isReels
                  borderColor="rgba(247, 247, 247, 1)"
                />
              ))}
            </div>
            <Text variant="secondary">
              {videoCrosspostContentsCount} {pluralize('video', videoCrosspostContentsCount)}
            </Text>

            <Text variant="secondary" color="var(--dark-40)">
              /week
            </Text>
          </div>
          <div className={Styles.separator} />
        </>
      )}
      {newsletterContentsCount > 0 && (
        <>
          <div className={Styles.strategyValue}>
            <Text variant="secondary">
              {newsletterContentsCount} {pluralize('email', newsletterContentsCount)}
            </Text>
            <Text variant="secondary" color="var(--dark-40)">
              /week
            </Text>
          </div>
          <div className={Styles.separator} />
        </>
      )}
      {seoContentsCount > 0 && (
        <>
          <div className={Styles.strategyValue}>
            <Text variant="secondary">
              {seoContentsCount} {pluralize('blog', seoContentsCount)}
            </Text>
            <Text variant="secondary" color="var(--dark-40)">
              /week
            </Text>
          </div>
        </>
      )}
    </div>
  )
}
